import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function VehicleEventsCtrl (
  $scope,
  $state,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showVehicleEvents = !!$scope.events.length;
  $scope.tableCacheKey     = 'vehicleEvents';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'event_number',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.BOOKING_NUMBER')
        },
        classes: 'all-caps'
      },
      {
        field : 'event_date',
        header: {
          text: $translate.instant('BOOKING_SPACE.BOOKING_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'event_status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'invoiceStatus'
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'total',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe: 'globalCurrency'
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewEvent(event)
            }
          },
          enabled: !$scope.vehicle.archived,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_BOOKINGS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vehicles/event_count/' + $scope.vehicle.id)
    },
    rows: {
      highlight: {
        enabled: true
      },
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'desc',
      field    : 'event_date'
    })
  };

  $scope.getEvents = ( params ) => {
    return workshopAPI.get('/vehicles/event_list', [
      $scope.vehicle.id,
      params.offset,
      params.pageSize,
      params.field,
      params.direction
    ]).then(events => {
      $scope.events = events;

      return events;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    if ( !$scope.vehicle.archived ) {
      $scope.viewEvent(event.row);
    }
  };

  $scope.viewEvent = function (event) {
    $state.go('app.event', {
      customer_id: $scope.customer.id,
      id         : event.id,
      vehicle_id : event.vehicle_id
    });
  };
};